export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/14ed8dc335eec8ccd043173219a4387f.svg";